export default (props) => {
    const { InspectorControls,getColorObjectByColorValue,useSetting } = wp.blockEditor;
    const { PanelBody, PanelRow , TextControl,RangeControl,ColorPalette } = wp.components;
    const {debounce} = _ ;
    const { useState,useMemo  } = React;
    const [iconeOptions,setIconeOptions] = useState([]);
    const [iconeField,setIconeField] = useState([]);
    const palette = useSetting( 'color.palette' );
    const {FormatedFaIcon} = cdm_blocks.components;

    let color_enabled = true;
    if(props.disableColor != undefined && props.disableColor == true){
        color_enabled = false;
    }

    let size_enabled = true;
    if(props.disableSize != undefined && props.disableSize == true){
        size_enabled = false;
        if(props.attributes.size != 3){
            props.setAttributes({size:3})
        }
    }

    const ontextFieldChangeHandler = useMemo(()=>{
        return debounce(nextValue=>{
            if(nextValue=== '') return;
            fetchFontAwesomeIcons(nextValue);
        }, 500);
    },[])


    const fetchFontAwesomeIcons = (search) => {
        fetch('https://api.fontawesome.com',{
            method:'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: `query { 
                            search(version:"6.1.1",query:"${search}",first:12) { 
                                id
                                label,
                                styles 
                                membership{
                                    free
                                }
                            } 
                        }`
            }),
        })
        .then((res)=>res.json())
        .then((results)=>{
            if(results.data)
                if(results.data.search)
                    setIconeOptions(results.data.search)
        })
    }

    return  <InspectorControls>
                <PanelBody title={ <p>
                                        <i class="fa-solid fa-font-awesome"></i>    
                                        {wp.i18n.__(" Options d'icônes",'theme-client')}
                                    </p> } >
                    <PanelRow>
                        <h4 level={4}>{wp.i18n._x("Sélection de l'icône (anglais)",'cdm-fa','theme-client')}</h4>
                        <TextControl 
                            value={iconeField}
                            onChange={(val)=>{ontextFieldChangeHandler(val);setIconeField(val);}}
                        />
                    </PanelRow>
                    <PanelRow>
                        <div className={"liste-icones-fa"} >
                            { iconeOptions.map(iconData => <div
                                className={iconData.id === props.attributes.icone.id?'selected':''} 
                                onClick={()=>{
                                    props.setAttributes({
                                        icone:iconData,
                                        style:iconData.styles[0]
                                    })
                                }
                            }>
                                <FormatedFaIcon align={'center'} color={props.attributes.iconColor ? props.attributes.iconColor.slug : ''} style={iconData.styles[0]} size={3} iconId={iconData.id} />
                                <p>{ iconData.label }</p>
                            </div>) }
                        </div>
                    </PanelRow>
                    
                    <PanelRow>
                        <h4 level={4}>{wp.i18n._x("Le style de l'icône",'cdm-fa','theme-client')}</h4>
                        <div className={"liste-icones-fa"} >
                            { props.attributes.icone.styles.map(style => <div
                                className={style === props.attributes.style?'selected':''} 
                                
                                onClick={()=>{
                                    props.setAttributes({
                                        style:style
                                    })
                                }
                            }>
                                <FormatedFaIcon align={'center'} color={props.attributes.iconColor ? props.attributes.iconColor.slug : ''} style={style} iconId={props.attributes.icone.id} />
                                <p>{ style }</p>
                                {(props.attributes.icone.membership.free.includes(style))?<span>Pro</span>:''}
                            </div>) }
                        </div>
                    </PanelRow>
                    { color_enabled &&
                        <PanelRow>
                            <h4 level={4}>{wp.i18n.__("Couleur de l'icône",'theme-client')}</h4>
                            <ColorPalette
                                disableCustomColors={true}
                                colors={palette}
                                value={ props.attributes.iconColor ? props.attributes.iconColor.color : '' }
                                onChange={ (val)=>props.setAttributes({iconColor:getColorObjectByColorValue(palette,val)}) }
                            />
                        </PanelRow>
                    }
                    { size_enabled &&
                        <PanelRow>
                            <h4 className={'before-range-control'} level={4}>{wp.i18n._x("Taille de l'icône",'cdm-fa','theme-client')}</h4>
                            <RangeControl
                                className={'range-go-100'}
                                label={wp.i18n._x('Tailles','cdm-fa','theme-client')}
                                max={4}
                                min={0}
                                value={props.attributes.size}
                                onChange={(val)=>props.setAttributes({size:val})}
                                step={1}
                                withInputField={false}
                                marks={[
                                    { value: 0,label: wp.i18n._x('Très petit','cdm-fa','theme-client')},
                                    { value: 1,label: wp.i18n._x('Petit','cdm-fa','theme-client')},
                                    { value: 2,label: wp.i18n._x('Moyen','cdm-fa','theme-client')},
                                    { value: 3,label: wp.i18n._x('Grand','cdm-fa','theme-client')},
                                    { value: 4,label: wp.i18n._x('Très grand','cdm-fa','theme-client')}
                                ]}
                            />
                        </PanelRow>
                    }      
                </PanelBody>
            </InspectorControls>
}
